export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/d2d966b0-af35-427b-a95c-2325ed3172c8.jpg',
  portrait: 'https://cdn.magicpatterns.com/patterns/generated-images/e6478eac-6c74-4a38-b963-8152ee8e0451.jpg',
  warehouse: 'https://cdn.magicpatterns.com/patterns/generated-images/cf8c51f5-b8df-40e7-9880-5b0a6c01947d.jpg',
  meeting: 'https://cdn.magicpatterns.com/patterns/generated-images/b7ca6291-a92d-4397-a552-1c9d76b5815f.jpg',
  port: 'https://cdn.magicpatterns.com/patterns/generated-images/ecdc7653-dabe-4868-aeff-fbc57b8e81cc.jpg',
};
